<template>
  <article>
   <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <el-select class="filter__input" size="mini" v-model="filters.sgid" filterable placeholder="请选择">
          <el-option :label="item.title" :value="item.sgid" v-for="(item, index) in goodsLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">规格名：</div>
        <el-input v-model="filters.category" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">属性名：</div>
        <el-input v-model="filters.content" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="ml-auto">
        <button class="blue-small-btn mr-10" @click="getList">搜索</button>
        <button class="blue-small-btn" @click="detailDialog = !detailDialog">新建</button>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700">
      <el-table-column prop="gsid" label="库存ID" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="sgid" label="商品" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.title}}({{scope.row.sgid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="category_key" label="规格ID" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="category" label="规格名" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="feature_key" label="属性ID" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="content" label="属性名" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="price" label="销售价" width="" align="center">
      </el-table-column>
      <el-table-column prop="min_price" label="成本价" width="" align="center">
      </el-table-column>
      <el-table-column prop="total" label="总量" width="" align="center">
      </el-table-column>
      <el-table-column prop="sold" label="已售" width="" align="center">
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <button class="blue-small-btn" @click="editDetail(scope.$index)">编辑</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="库存编辑" :visible.sync="detailDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">库存ID</div>
            <el-input v-model="detail.gsid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">总量</div>
            <el-input v-model="detail.total" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">销售价：</div>
            <el-input placeholder="" v-model="detail.price" class="dataForm__input" size="mini" @input="(v)=>(detail.price=v.replace(/[^\d.]/g,''))">
              <template slot="append">￥</template>
            </el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">成本价：</div>
            <el-input placeholder="" v-model="detail.min_price" class="dataForm__input" size="mini" @input="(v)=>(detail.min_price=v.replace(/[^\d.]/g,''))">
              <template slot="append">￥</template>
            </el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="shopGoodsStockEdit">保存</div>
          <div class="gray-large-btn" @click="detailDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>
<script>
import util from '../../../script/util'
import {shopGoodsLists, shopGoodsStockLists, shopGoodsStockEdit} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
export default {
  name: 'shopGoodsStock',
  components: {
    uploadHeadImage
  },
  data () {
    return {
      filters: {
        p: 1,
        l: 20,
        total: 0,
        sgid: '',
        category: '',
        content: ''
      },
      lists: [],
      goodsLists: [],
      listLoading: false,
      detailDialog: false,
      detail: {
        gsid: 0,
        total: '',
        price: '',
        min_price: ''
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    editDetail (index) {
      this.detailDialog = true
      for (let key in this.detail) {
        this.detail[key] = this.lists[index][key]
      }
    },
    shopGoodsStockEdit () {
      let params = {
        gsid: this.detail.gsid,
        total: this.detail.total,
        price: this.detail.price,
        min_price: this.detail.min_price
      }

      shopGoodsStockEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.detailDialog = false
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.sgid !== '') {
        params.sgid = filters.sgid
      }

      if (filters.category !== '') {
        params.category = filters.category
      }

      if (filters.content !== '') {
        params.content = filters.content
      }

      this.listLoading = true
      shopGoodsStockLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    getGoodsLists () {
      let params = {
      }

      this.listLoading = true
      shopGoodsLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.goodsLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.sgid + ')',
              sgid: item.sgid
            }
          })
          this.goodsLists.unshift({
            title: '所有',
            sgid: ''
          })
        }
      })
    }
  },
  mounted () {
    this.getGoodsLists()
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.sgid': 'getList',
    'filters.category': 'getList',
    'filters.content': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/shop/shopGoodsStock.vue